// extracted by mini-css-extract-plugin
export default {"labelTd":"ThongTinDonvi_labelTd__n1ihr","tr":"ThongTinDonvi_tr__Dh6cd"};